import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import CalendarTime from '../../../shared/components/CalendarTime';
import Link from '../../../shared/components/Link';
import { DATE_FORMAT } from '../../../shared/constants';
import { formatDate } from '../../../shared/utils/formatCalendarTime';
import getTimeZoneFormat from '../../../shared/utils/getTimeZoneFormat';
import style from './ProviderCardOpenings.scss';

export default function ProviderCardOpenings({
  providerUrl,
  nextAvailableUrl,
  startingDate,
  timeZone,
}) {
  const intl = useIntl();
  const timeZoneFormat = getTimeZoneFormat(timeZone);

  return (
    <div className={style['provider-card-openings']}>
      <section
        className={style['provider-card-openings__availibility']}
        data-qa="provider-card__availibility"
      >
        <p>
          <Link to={providerUrl}>Accepting scheduling online</Link>
          <br />
          Openings starting{' '}
          {formatDate(intl, startingDate, timeZoneFormat, {
            intl: DATE_FORMAT.MEDIUM_NO_YEAR,
            fallback: DATE_FORMAT.MEDIUM_NO_YEAR_FALLBACK,
          })}
          .
        </p>
      </section>
      <div
        className={style['provider-card-openings__next-opening']}
        data-qa="provider-card__next-opening"
      >
        <p>
          Next Opening{' '}
          <Link to={nextAvailableUrl} itemProp="url">
            <CalendarTime datetime={startingDate} timeZone={timeZone} />
          </Link>
        </p>
      </div>
    </div>
  );
}

ProviderCardOpenings.propTypes = {
  providerUrl: PropTypes.string.isRequired,
  nextAvailableUrl: PropTypes.string.isRequired,
  startingDate: PropTypes.shape({
    toISOString: PropTypes.func.isRequired,
  }).isRequired,
  timeZone: PropTypes.string,
};
